<div class="news-viewer">
  <!-- Loading state -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-3">Cargando artículo...</p>
  </div>

  <!-- Error state -->
  <div class="error-state" *ngIf="error">
    <div class="container">
      <h2>Artículo no encontrado</h2>
      <p>Lo sentimos, el artículo que buscas no está disponible en este momento.</p>
      <a routerLink="/home" class="btn btn-primary">Volver al inicio</a>
    </div>
  </div>

  <!-- Article content -->
  <article class="article-content" *ngIf="(!loading && !error && article) || previewMode">
    <!-- Hero section -->
    <div class="article-hero" [ngStyle]="heroImageStyle">
      <img *ngIf="showHeroImage" [src]="heroImageUrl" alt="Imagen principal del artículo" class="hero-image">
      <div class="hero-overlay">
        <div class="container">
          <div class="hero-content">
            <div class="meta">
              <span class="category">{{ article?.category }}</span>
              <span class="date" *ngIf="!previewMode">{{ getFormattedDate(article?.publishDate) }}</span>
              <span class="date" *ngIf="previewMode">(Vista Previa)</span>
            </div>
            <h1 class="title">{{ article?.title }}</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Article metadata -->
    <div class="article-meta" *ngIf="!previewMode">
      <div class="author" *ngIf="article?.author">
        <span class="author-label">Por</span>
        <span class="author-name">{{ article?.author }}</span>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <!-- Subtitle -->
        <div class="col-12">
          <h2 class="subtitle" id="subtitle" *ngIf="article?.subtitle" [ngStyle]="subtitleStyle">{{ article?.subtitle }}</h2>
        </div>

        <!-- Article content column -->
        <div class="col-lg-8">
          <!-- Article body -->
          <div class="article-body">
            <div *ngFor="let paragraph of article?.paragraphs" class="paragraph-block" style="margin-bottom: -15px !important;">
              <h4 *ngIf="paragraph.title" class="paragraph-title" style="margin-bottom: 0.50rem; font-weight: 600; margin-top: 10px !important; padding-top: 10px !important;">{{ paragraph.title }}</h4>
              <p class="paragraph-content" [innerHTML]="sanitizeHtml(paragraph.content)" style="margin-top: -10px !important; padding-top: 10px !important; margin-bottom: 15px !important; font-size: 1.2rem !important; line-height: 1.85 !important;"></p>

              <figure *ngIf="paragraph.image" class="paragraph-image">
                <img [src]="paragraph.image" [alt]="paragraph.imageCaption || 'Imagen del artículo'" class="img-fluid">
                <figcaption *ngIf="paragraph.imageCaption">
                  {{ paragraph.imageCaption }}
                </figcaption>
              </figure>

               <!-- Video -->
               <div class="row mb-3" *ngIf="paragraph.urlVideo"
               style="margin: 0.1rem !important; margin-top: 1.6rem !important; margin-bottom: 10px !important;">
               <!-- Video embebido -->
               <div *ngIf="paragraph.urlVideo" class="video-container">
                 <iframe *ngIf="isYouTubeUrl(paragraph.urlVideo)" [src]="getSafeVideoUrl(paragraph.urlVideo)"
                   frameborder="0"
                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                   allowfullscreen width="100%" height="315">
                 </iframe>
                 <iframe *ngIf="isFacebookUrl(paragraph.urlVideo)" [src]="getSafeVideoUrl(paragraph.urlVideo)"
                   frameborder="0" allowfullscreen width="100%" height="315">
                 </iframe>
               </div>
            
                <!-- Agrega otros casos similares para Instagram u otras plataformas -->
                <p class="pie-imagen-1" *ngIf="paragraph.pieDeVideo"
                  style="margin-top: -25px ! important; margin-bottom: 10px ! important;">{{ paragraph.pieDeVideo }}</p>
              </div> <!-- Cierre del div.row del video -->
            </div> <!-- Cierre del div.content-paragraph -->
          </div> <!-- Cierre del *ngFor para cada párrafo -->

          <!-- Compartir en redes sociales -->
          <div class="share-container" *ngIf="!previewMode">
            <h6 class="share-title">Compartí esta noticia</h6>
            <div class="social-icons">
              <button (click)="shareContent('facebook')" class="social-icon">
                <i class="fab fa-facebook"></i>
              </button>
              <button (click)="shareContent('twitter')" class="social-icon">
                <i class="fab fa-x-twitter"></i>
              </button>
              <button (click)="shareContent('linkedin')" class="social-icon">
                <i class="fab fa-linkedin"></i>
              </button>
              <button (click)="shareContent('whatsapp')" class="social-icon">
                <i class="fab fa-whatsapp"></i>
              </button>
            </div>
          </div>

          <!-- Tags -->
          <div class="article-tags" *ngIf="article?.tags?.length" style="margin-top: 2rem; margin-bottom: 2rem;">
            <div class="tags-list">
              <span *ngFor="let tag of article?.tags" class="tag" [class.preview]="previewMode">
                #{{ tag }}
              </span>
            </div>
          </div>
        </div>

      <!-- Sidebar column -->
      <div class="col-lg-4 mt-5" *ngIf="!previewMode" style="margin-top: 1rem !important;">
         <!-- Latest news -->
        <div class="sidebar-section latest-news" *ngIf="latestNews.length > 0">
          <h3>Últimas Noticias</h3>
          <div class="article-list">
            <a *ngFor="let latestArticle of latestNews" [routerLink]="['/noticias', latestArticle.slug]" class="article-card">
              <div class="article-image">
                <img *ngIf="getImageSrc(latestArticle)" [src]="getImageSrc(latestArticle)" alt="Imagen del artículo" class="sidebar-img">
              </div>
              <div class="article-info">
                <span class="category">{{ latestArticle.category }}</span>
                <h4 class="title">{{ latestArticle.title }}</h4>
                <span class="date">{{ getFormattedDate(latestArticle.publishDate) }}</span>
              </div>
            </a>
          </div>
        </div>
        <!-- Related articles -->
        <div class="sidebar-section related-articles" *ngIf="relatedArticles.length > 0">
          <h3>Noticias Relacionadas</h3>
          <div class="article-list">
            <a *ngFor="let relatedArticle of relatedArticles" [routerLink]="['/noticias', relatedArticle.slug]"
              class="article-card">
              <div class="article-image">
                <img *ngIf="getImageSrc(relatedArticle)" [src]="getImageSrc(relatedArticle)" alt="Imagen del artículo" class="sidebar-img">
              </div>
              <div class="article-info">
                <span class="category">{{ relatedArticle.category }}</span>
                <h4 class="title">{{ relatedArticle.title }}</h4>
                <span class="date">{{ getFormattedDate(relatedArticle.publishDate) }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </article>
</div>